<template>
  <transition name="router-animation" mode="out-in">
    <router-view id="PageWrapper" ref="content" :key="$route.fullPath" />
  </transition>
</template>

<script>
export default {
  name: 'Default',
};
</script>
